module.exports = __webpack_public_path__ + "static/media/phone.786a0776.fbebb627.svg";